module.exports = __webpack_public_path__ + "static/media/kanban1.a46cb929.svg";